<template>
    <div id="widget" class="widget row">
        <h3 class="block-title w-100"><span>{{title}}</span></h3>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Widget',
        props: ['title'],
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    .widget {
        .block-title {
            border-bottom: 2px solid $dark-grey;
            font-size: 14px;
            line-height: 100%;
            margin: 0 0 40px;
            text-transform: uppercase;

            span {
                background: $dark-grey;
                color: #fff;
                height: 30px;
                line-height: 30px;
                padding: 8px 15px;
                position: relative;
            }

            span:after {
                border-color: #272727 rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
                position: absolute;
                content: " ";
                width: auto;
                height: auto;
                bottom: -20px;
                margin-left: -10px;
                left: 50%;
                border-width: 10px;
                border-style: solid;
            }
        }
    }
</style>